// modules/website/components/SpacerComponent.tsx - Espaçador/Divisor

import React from 'react';
import { SpacerData } from '@/types';

interface Props {
  data: SpacerData;
  settings?: any;
}

export const SpacerComponent: React.FC<Props> = ({ data, settings }) => {
  const { 
    height = '40px', 
    showDivider = false, 
    dividerStyle = 'solid', 
    dividerColor = '#e5e7eb' 
  } = data || {};

  return (
    <div 
      className="w-full"
      style={{ 
        height: showDivider ? 'auto' : height,
        paddingTop: showDivider ? height : undefined,
        paddingBottom: showDivider ? height : undefined,
        backgroundColor: settings?.backgroundColor
      }}
    >
      {showDivider && (
        <div 
          className="max-w-4xl mx-auto"
          style={{
            borderTopWidth: '1px',
            borderTopStyle: dividerStyle,
            borderTopColor: dividerColor
          }}
        />
      )}
    </div>
  );
};
